import React, { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import logger from "../../Logger"
import UserContext from "./user-context"
import HelpCenter from "../../components/common/Help/HelpCenter"
import ErrorBoundary from "../../components/common/ErrorBoundary/ErrorBoundary"

const pageLogger = logger.child({ context: "user" })

const UserState = (props) => {
  // No real backing API for a user directory/roles list exists yet — keep these empty
  // rather than loading the sample public/data/*.json fixtures into context.
  const [userDataList] = useState([])
  const [userRoleList] = useState([])

  const [userData, setUserData] = useState(null)

  useEffect(() => {
    pageLogger.info({ userData }, `userData`)
  }, [userData])

  const setCurrentUser = (newUserData) => {
    setUserData(newUserData)
  }

  const updateCurrentUserState = (userKey, updateValue) => {
    const tempUser = { ...userData }
    tempUser[userKey] = updateValue
    setUserData(tempUser)
  }

  return (
    <UserContext.Provider
      value={{
        userData,
        userDataList,
        userRoleList,
        setCurrentUser,
        updateCurrentUserState,
        /* updateUserAchievements */
      }}
    >
      <Outlet />
      {/* In-product help lives here (above both AppLayout and the standalone gameplay/
          builder routes) so the "?" is available on EVERY authenticated page — including
          gameplay and the facilitator view, which render outside the app chrome. */}
      <ErrorBoundary fallback={null}>
        <HelpCenter />
      </ErrorBoundary>
    </UserContext.Provider>
  )
}

export default UserState
